var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AwsCredentials_1;
import { JSON, JsonSchemaV2, JsonConverter, DateConverter } from '@symon-ai/wisepipe-serialize';
import { awsCredentialsSchemaValidation } from '../validations.generated';
export const awsCredentialsSchema = {
    $id: 'urn:wisepipe-common-auth:AwsCredentials',
    type: 'object',
    properties: {
        identityID: { type: 'string', pattern: '[\\w-]+:[0-9a-f-]+' },
        accessKeyID: { type: 'string', minLength: 1, pattern: '[\\w]+' },
        secretKey: { type: 'string', minLength: 1 },
        sessionToken: { type: 'string', minLength: 1 },
        expiration: { type: 'string', format: 'date-time' },
        region: { type: 'string' }
    },
    required: ['identityID', 'accessKeyID', 'secretKey', 'sessionToken', 'expiration', 'region']
};
let AwsCredentials = AwsCredentials_1 = class AwsCredentials {
    constructor(identityID, accessKeyID, secretKey, sessionToken, expiration, region) {
        this.identityID = identityID;
        this.accessKeyID = accessKeyID;
        this.secretKey = secretKey;
        this.sessionToken = sessionToken;
        this.expiration = expiration;
        this.region = region;
        JSON.validate(this, AwsCredentials_1);
    }
    async encrypt(encryptFn) {
        const enSecretKey = await encryptFn(this.secretKey);
        const enSessionToken = await encryptFn(this.sessionToken);
        return new AwsCredentials_1(this.identityID, this.accessKeyID, enSecretKey, enSessionToken, this.expiration, this.region);
    }
    async decrypt(decryptFn) {
        const deSecretKey = await decryptFn(this.secretKey);
        const deSessionToken = await decryptFn(this.sessionToken);
        return new AwsCredentials_1(this.identityID, this.accessKeyID, deSecretKey, deSessionToken, this.expiration, this.region);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], AwsCredentials.prototype, "expiration", void 0);
AwsCredentials = AwsCredentials_1 = __decorate([
    JsonSchemaV2(awsCredentialsSchema, awsCredentialsSchemaValidation)
], AwsCredentials);
export { AwsCredentials };
//# sourceMappingURL=awsCredentials.js.map